<template>
  <div class="location">
    <div class="row">
      <div class="col-12 col-lg-6">
        <select v-model="regionId" @change="regionChange">
          <option :value="null">Выберите регион</option>
          <option v-for="loc in location" :key="loc.id" v-bind:value="loc.id">
            {{ loc.title }}
          </option>
        </select>
      </div>
      <div class="col-12 col-lg-6">
        <select
          v-model="cityId"
          :disabled="cities.length === 0"
          @change="cityChange"
        >
        
          <option :value="null">Выберите город</option>

          <option v-for="city in cities" :key="city.id" v-bind:value="city.id">
            {{ city.title }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "Search",
  props: {
    city: {
      default: null,
    },
    region: {
      default: null,
    },
  },
  data() {
    return {
      cities: [],
      regionId: null,
      cityId: null,
    };
  },
  created() {
    setTimeout(() => {
      this.regionId = this.region;
      if (this.regionId && this.regionId > 0) {
        this.cities = this.location[this.regionId].child;
      }
      this.cityId = this.city;
    }, 0);
  },
  methods: {
    regionChange(e) {
      this.regionId = e.target.value;
      if (this.regionId && this.regionId > 0) {
        this.cities = this.location[this.regionId].child;
      } else {
        this.cities = [];
        this.$emit("input", null);
      }
    },
    cityChange(e) {
      this.cityId = e.target.value;
      if (this.cityId && this.cityId > 0) {
        this.$emit("input", this.cityId);
      } else {
        this.$emit("input", null);
      }
    },
  },
  computed: {
    ...mapState(["location"]),
  },
};
</script>
<style lang="scss">
.location {
  select {
    padding: 5px 10px 5px 5px;
    width: 100%;
    height: 34px;
    border-radius: 10px;
    margin-bottom: 15px;
  }
}
</style>
